import React, { useState, useEffect,useContext } from "react";
import { AppContext } from "../../AppContext";

import DateUtil from "../../common/dateUtil";
import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";

import ReqControlHeader from "../common/ReqControlHeader";

import GiftSearchComp from "./GiftSearchComp";
import GiftEditorComp from "./GiftEditorComp";
import { fetchCall } from "../../common/FetchHelpers";

const GiftComp = (props) => {
  
  const summaryUrl = "api/gift/reqsummary";

  const [appContext, setAppContext] = useContext(AppContext);

  const emptyEditorItem = {   
    id:-1,
    status:"",
    giftType : "Gift",
    description : "",
    giftDate : "",
    address : "",
    giftValue:"",
    currency:"",
    recipients:"",
    governmentRecipients:"",
    raffleContest:"",
    attachment:null,
    isGovRecipients:"N",
    isRaffleContest:"N",
    submittedFor:null
  }
 
  const [showingList, setShowingList] = useState(true);
  const [showingEditor, setShowingEditor] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editorItem, setEditorItem] = useState(emptyEditorItem);
  const [editorMode, setEditorMode] = useState("NEW");


  const addNewClickHandler = () => {
    setEditorItem(emptyEditorItem);
    setControlParam((p) => {
      return { ...p, mode: "add" };
    });


    setShowingList(false);
    setShowingEditor(true);
  };

  const showListHandler = () => {
    setControlParam((p) => {
      return { ...p, mode: "view" };
    });
    setShowingEditor(false);
    setShowingList(true);
  };

  const handleUpdate=(data)=>{
    setEditorMode("UPDATE");
    const giftDate = DateUtil.toDate(data.giftDate);
      const item = {
        ...data,
        giftDate,
        isGovRecipients:data.governmentRecipients===null?"N":"Y",
        governmentRecipients:data.governmentRecipients===null?"":data.governmentRecipients,
        isRaffleContest:data.raffleContest===null?"N":"Y",
        raffleContest:data.raffleContest===null?"":data.raffleContest
      };
   
      console.log(item);
  
      setEditorItem(item);
      setShowingList(false);
      setShowingEditor(true);
  };


  const [controlParam, setControlParam] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
    btnAddLabel: "Create a New Request",
    mode: "view",
    addNewClickHandler,
    showListHandler,
  });


  useEffect(() => {

    fetchCall(summaryUrl)
      .then((result) =>{
        setControlParam({
          ...controlParam,
          approved: result.giftRequest.approved,
          pending: result.giftRequest.pending,
          rejected: result.giftRequest.rejected,
        });
        setLoading(false);
      },
      (err)=>{
        setLoading(false);
        setShowError(true);
      }
    );
  }, [appContext.reloadSummary]);





  return (
    <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
      <section className="section-wrapper">
        <div className="page-title">Gifts & Entertainment Request</div>
        <div className="section-content">
          <ReqControlHeader params={controlParam} />
          <div className="section-body">
            {showingList && <GiftSearchComp handleUpdate={handleUpdate} giftId={props.match.params.id} t={props.match.params.t}/>}
            {showingEditor && <GiftEditorComp handleClose={showListHandler} formData={editorItem} editorMode={editorMode}/>}
            {showError && <ErrorComp />}
            {loading && <LoadingComp />}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GiftComp;
